// Component names
export const GLOBAL_SEARCH_COMPONENT = 'nav-components:global-search';
export const DUMMY_COMPONENT = 'nav-components:dummy';
export const CHATSPOT_SIDEBAR_COMPONENT = 'nav-components:chatspot-sidebar';
export const IN_APP_HELP_COMPONENT = 'nav-components:in-app-help';
export const GROWTH_PROMPTS_COMPONENT = 'nav-components:growth-prompts';
export const NOTIFICATIONS_BANNER_COMPONENT = 'nav-components:notifications-banner';
export const NOTIFICATIONS_FLOATING_COMPONENT = 'nav-components:notifications-floating';
export const NOTIFICATIONS_TEASE_COMPONENT = 'nav-components:notifications-tease';
export const NOTIFICATIONS_SIDEBAR_COMPONENT = 'nav-components:notifications-sidebar';
export const CALLING_COMPONENT = 'nav-components:calling';
export const OBJECT_BUILDER_NAV_COMPONENT = 'nav-components:object-builder-nav';
export const NAV_OBJECT_CREATE_COMPONENT = 'nav-components:nav-object-create';
export const MARKETPLACE_MODAL_COMPONENT = 'nav-components:marketplace-modal';
export const BREEZE_IMAGE_MODAL_COMPONENT = 'nav-components:breeze-image-modal';
export const MARKETPLACE_NAV_MENU_COMPONENT = 'nav-components:marketplace-nav-menu';
export const ACADEMY_TOOLBAR_COMPONENT = 'nav-components:academy-toolbar';
export const ACADEMY_PRACTICE_MODE_TOOLBAR_COMPONENT = 'nav-components:academy-practice-mode-toolbar';
export const ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT = 'nav-components:academy-exercise-instructions';
export const ACADEMY_VIDEO_HOST_COMPONENT = 'nav-components:academy-video-host';
export const ACADEMY_PRACTICE_MODE_STARTER_COMPONENT = 'nav-components:academy-practice-mode-starter';
export const NAV_ONBOARDING_TOURS_COMPONENT = 'nav-components:nav-onboarding-tours';
export const USER_INVITE_MODAL_COMPONENT = 'nav-components:user-invite-modal';
export const GROWTH_IN_APP_SIDEPANEL_COMPONENT = 'nav-components:growth-in-app-sidepanel';
export const MINI_TRIAL_GUIDE_COMPONENT = 'nav-components:mini-trial-guide';
export const GROW_GUIDE_COMPONENT = 'nav-components:grow-guide';
export const GROWTH_ONBOARDING_NEXT_ACTION_MODAL_COMPONENT = 'nav-components:growth-onboarding-next-action-modal';
export const GROWTH_ONBOARDING_COMPANION_COMPONENT = 'nav-components:growth-onboarding-companion';
export const ACADEMY_RECOMMENDATIONS_MODAL_COMPONENT = 'nav-components:academy-recommendations-modal';
export const BREEZE_EMAIL_SUPPORT_MODAL_COMPONENT = 'nav-components:breeze-email-support-modal';
export const GROWTH_REQUEST_SEAT_MODAL_COMPONENT = 'nav-components:growth-request-seat-modal';
export const BOOKMARKS_MANAGER_COMPONENT = 'nav-components:bookmarks-manager';
export const PAPERCUTS_FEEDBACK_COMPONENT = 'nav-components:papercuts-feedback';
export const BREEZE_PROJECTS_UI_MODAL_COMPONENT = 'nav-components:breeze-projects-ui-modal';
export const BREEZE_SHARING_UI_MODAL_COMPONENT = 'nav-components:breeze-sharing-ui-modal';
export const CONNECTION_SETTINGS_MODAL_COMPONENT = 'nav-components:connection-settings-modal';
export const GROUPS_MANAGER_COMPONENT = 'nav-components:groups-manager';
export const TALK_TO_SALES_MODAL_COMPONENT = 'nav-components:talk-to-sales-modal';
export const TRIAL_START_MODAL_COMPONENT = 'nav-components:trial-start-modal';

// Component tags
export const Tags = {
  SIDE_PANEL: 'SIDE_PANEL',
  MODAL: 'MODAL',
  BANNER: 'BANNER'
};
// Loggers
export const PLATFORM_LOGGER = 'NAVIGATION_COMPONENTS_PLATFORM_LOGGER';
export const SCHEDULER_LOGGER = 'NAVIGATION_COMPONENTS_SCHEDULER_LOGGER';

// Others
export const DEFAULT_PLATFORM_NAME = 'unified-navigation-ui';
export const NC_PLATFORM_NAME = 'unified-navigation-ui';